import React, { Component } from 'react';
import { borders, oyoFormView, validation } from '../../../Enums';
import BackIcon from '../../../resources/vectors/BackIcon';
import { EVENT_ACTIONS, EVENT_CATEGORIES, logEvent } from '../../../services/Analytics';

class HotelStepTwoWidget extends Component {
  state = {
    hotel_address_border: borders.NORMAL_BORDER,
    email_border: borders.NORMAL_BORDER,
    hotel_name_border: borders.NORMAL_BORDER
  };

  render() {
    let gs = this.props.gs;
    let gc = this.props.gc;
    let guc = this.props.guc;
    return (
      <div>
          <BackIcon className={'hover'} onClick={() => {
              this.props.changeFormScreen(oyoFormView.checkEarnings);
          }} style={gs('back')}/>
        <div style={gs('big_text_form')}>{guc('tell_us_more')}</div>

        <div style={{...gs('form_small_text'),marginTop:'4px'}}>{guc('prop_address')}</div>
        <input
          placeholder={''}
          type="text"
          autoComplete="new-password"
          onChange={e => {
            this.props.globalActions.dataUpdate(
              'hotel_address',
              e.target.value
            );
              logEvent(EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM_HOTEL, EVENT_ACTIONS.ADDRESS_ENTERED, e.target.value);
              if (!this.props.hotel_address_border_validated) {
              this.props.validateOneField(validation.HOME_ADDRESS);
            }
          }}
          value={this.props.globalData.formData.hotel_address}
          className={'removeFocusOutline'}
          style={{
            ...gs('input_form'),
            border: this.props.hotel_address_border_validated
              ? this.state.hotel_address_border
              : borders.RED_BORDER
          }}
          onFocus={() => {
            this.setState({
              hotel_address_border: borders.ACTIVE_BORDER
            });
          }}
          onBlur={() => {
            this.setState({
              hotel_address_border: borders.NORMAL_BORDER
            });
          }}
        />

        <div style={gs('form_small_text')}>{guc('prop_name')}</div>
        <input
          placeholder={''}
          type="text"
          autoComplete="new-password"
          onChange={e => {
              this.props.globalActions.dataUpdate('hotel_name', e.target.value);
              logEvent(EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM_HOTEL, EVENT_ACTIONS.PROPERTY_NAME_ENTERED, e.target.value);
              if (!this.props.hotel_name_border_validated) {
              this.props.validateOneField(validation.HOTEL_PROPERTY_NAME);
            }
          }}
          value={this.props.globalData.formData.hotel_name}
          className={'removeFocusOutline'}
          style={{
            ...gs('input_form'),
            border: this.props.hotel_name_border_validated
              ? this.state.hotel_name_border
              : borders.RED_BORDER
          }}
          onFocus={() => {
            this.setState({
              hotel_name_border: borders.ACTIVE_BORDER
            });
          }}
          onBlur={() => {
            this.setState({
              hotel_name_border: borders.NORMAL_BORDER
            });
          }}
        />

        <div style={gs('form_small_text')}>{guc('your_email') + '*'}</div>
        <input
          placeholder={''}
          type="text"
          autoComplete="new-password"
          onChange={e => {
            if (!this.props.email_border_validated) {
              this.props.validateOneField(validation.HOTEL_EMAIL);
            }
              logEvent(EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM_HOTEL, EVENT_ACTIONS.EMAIL_ENTERED, e.target.value);
              this.props.globalActions.dataUpdate(
              'email_address',
              e.target.value
            );
          }}
          value={this.props.globalData.formData.email_address}
          className={'removeFocusOutline'}
          style={{
            ...gs('input_form'),
            border: this.props.email_border_validated
              ? this.state.email_border
              : borders.RED_BORDER
          }}
          onFocus={() => {
            this.setState({
              email_border: borders.ACTIVE_BORDER
            });
          }}
          onBlur={() => {
            this.setState({
              email_border: borders.NORMAL_BORDER
            });
          }}
        />
      </div>
    );
  }
}

export default HotelStepTwoWidget;
